import mainMenu from './main-menu.vue'

export default {
  install (Vue, options = {}) {
    Vue.component('main-menu', mainMenu)
  }
}
